import { atom } from 'recoil';

export const mainAnnouncementsState = atom<Announcement[]>({
  key: 'mainAnnouncementsState',
  default: [],
});
